// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"fcf3874d","574":"29b18104","787":"6a5ef954"}[chunkId] + ".chunk.js";
};